module.exports = __webpack_public_path__ + "static/media/Flexible Wires.4d86aedc.png";